import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { setIsModalxOpen } from "components/modalx/modalx.slice";
import { post } from "services/user-select.service";
import { fetchUsers } from "../users/users.slice";
import { fetchUserDetails } from "containers/user/user-container.slice";
import { toast } from "sonner";
import i18n from "i18n";
import { describePositionsError } from "features/positions/positions-errors";
import { isLastMasterError } from "utils/last-master-error";

const initialState = {
  isLoading: false,
  isError: false,
  isSuccessfullySaved: false,
  errMsg: null,
};
const userFormSlice = createSlice({
  name: "userForm",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
    },
    setError(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setSuccessfullySaved(state) {
      state.isLoading = false;
      state.isError = false;
      state.errMsg = null;
      state.isSuccessfullySaved = true;
    },
    destroy(state) {
      _.assign(state, initialState);
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = userFormSlice;

// Extract and export each action creator by name
export const { setLoading, setError, setSuccessfullySaved, destroy } = actions;

// Export the reducer, either as a default or named export
export default reducer;

/**
 * Resolves to true when saved; "stale" when someone changed the person's rights
 * since the form loaded them (the form then reloads them); false for any other
 * failure.
 */
export const submit = (companyId, data) => async (dispatch, getState) => {
  dispatch(setLoading());
  try {
    await post(data, companyId);
    dispatch(destroy());
    dispatch(setIsModalxOpen(false));
    // The users page shows the list under its current filters.
    dispatch(fetchUsers(companyId, getState().usersReducer.filtersValue));
    if (data?.userId && companyId) {
      dispatch(fetchUserDetails({ userId: data?.userId, companyId }));
    }
    return true;
  } catch (e) {
    const code = e?.response?.data?.code || e?.response?.data?.error;
    if (code === "POSITIONS_VIA_AMENDMENT" || code === "POSITIONS_REQUIRED") {
      // The employee has an onboarding record: positions change only through
      // a contract amendment (positions catalogue §4).
      toast.error(describePositionsError(e, i18n.t.bind(i18n)));
    }
    if (isLastMasterError(e)) {
      toast.error(i18n.t("last_master_error"));
    }
    if (code === "GROUPS_RETIRED") {
      // This page is older than the server: it still sends groups.
      toast.error(i18n.t("groups_retired_reload"));
    }
    if (code === "USER_HAS_OTHER_COMPANIES") {
      // Name, phone, code and gender are shared by all the person's companies.
      toast.error(i18n.t("user_has_other_companies"));
    }
    dispatch(setError("400"));
    // The form says so once it has loaded the rights as they are now.
    if (code === "STALE_PERMISSIONS") return "stale";
    return false;
  }
};
